import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ShopSettings, ShopSettingsRepository } from '@infrab4a/connect';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { FileControllerService } from 'src/app/admin-api';
import { CustomizationFormComponent } from 'src/app/components/customization/customization-form.component';
import { AppDialogService } from 'src/app/services/dialog.service';
import { ImageService } from 'src/app/services/image.service';

@Component({
  selector: 'app-call-and-win-form',
  templateUrl: './call-and-win-form.component.html',
  styleUrls: ['./call-and-win-form.component.scss']
})
export class CallAndWinFormComponent
  extends CustomizationFormComponent
  implements OnInit
{
  pageDocument: ShopSettings;
  checked = true;

  constructor(
    @Inject('ShopSettingsRepository')
    private shopSettingsRepository: ShopSettingsRepository,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private activatedRoute: ActivatedRoute,
    override router: Router,
    override config: PrimeNGConfig,
    override imageService: ImageService,
    override fileService: FileControllerService
  ) {
    super(router, config, imageService, fileService);

    this.documentId = 'CALL_AND_WIN';

    this.form = this.formBuilder.group({
      campaignName: ['', Validators.required],
      imageGift: ['', [Validators.required]],
      nameGift: ['', [Validators.required]],
      altText: ['', [Validators.required]],
      beginDate: [null, [Validators.required]],
      manuallyActive: [true]
    });
  }

  async ngOnInit() {
    await this.getDocument();
  }

  override async getDocument(): Promise<void> {
    try {
      this.pageDocument = await this.shopSettingsRepository.get({
        id: this.documentId
      });
      this.documentSections = this.pageDocument.sections || [];
      if (this.router.url.includes('edit')) {
        this.activatedRoute.params.subscribe((params) => {
          this.activeIndex = +params['index'];
          this.activeSection = this.documentSections[this.activeIndex];
          this.initializeForm();
        });
      }
    } catch (error) {
      this.form.patchValue(this.activeSection);
    }
  }

  override initializeForm(): void {
    this.form.patchValue(this.activeSection);
  }

  override async save() {
    if (this.form.valid) {
      if (this.activeSection)
        this.documentSections[this.activeIndex] = this.form.value;
      else this.documentSections.push(this.form.value);

      await this.shopSettingsRepository.update({
        id: this.documentId,
        sections: this.documentSections
      });

      this.messageService.add({
        severity: 'success',
        summary: 'Salvo com sucesso',
        detail: 'As informações foram salvas.'
      });
      await this.afterSubmit();

      this.navigate('/configuracoes/call-friends/call-and-win');
    } else {
      AppDialogService.showErrorDialog(
        {},
        false,
        'Formulário inválido. Não é possível salvar os dados.'
      );
    }
  }

  isBeginDateInvalid() {
    const beginDateControl = this.form.get('beginDate');
    return (
      beginDateControl?.invalid &&
      (beginDateControl?.touched || beginDateControl?.dirty)
    );
  }

  isCampaignNameInvalid() {
    const campaignNameControl = this.form.get('campaignName');
    return (
      campaignNameControl?.invalid &&
      (campaignNameControl?.touched || campaignNameControl?.dirty)
    );
  }

  isNameGiftInvalid() {
    const nameGiftControl = this.form.get('nameGift');
    return (
      nameGiftControl?.invalid &&
      (nameGiftControl?.touched || nameGiftControl?.dirty)
    );
  }

  isAltTextInvalid() {
    const altTextControl = this.form.get('altText');
    return (
      altTextControl?.invalid &&
      (altTextControl?.touched || altTextControl?.dirty)
    );
  }

  isDiscountInvalid() {
    const discountControl = this.form.get('discount');
    return (
      discountControl?.invalid &&
      (discountControl?.touched || discountControl?.dirty)
    );
  }

  async handleFileSelect(
    event: { files: File[] },
    inputName: string,
    expectedWidth: number,
    expectedHeight: number,
    maxWeight: number,
    pInput: FileUpload
  ) {
    this.fileNamePattern = `glampoints-call-and-win-${new Date().getTime()}.webp`;

    await this.upload(
      event,
      inputName,
      expectedWidth,
      expectedHeight,
      maxWeight,
      pInput
    );
  }

  goToMenu() {
    this.navigate('configuracoes/call-friends/call-and-win');
  }

  get imageGiftUrl(): string {
    return this.form.get('imageGift')?.value;
  }

  override get filePath(): string {
    return '/pages/call-and-win/';
  }

  override get model() {
    return this.pageDocument;
  }

  override get modelId() {
    return this.pageDocument?.id;
  }
}
